import { config } from "configs/config";
import { ApiError } from "src/services/apiClient";

export async function downloadChargesReceipt(year: number, month: number): Promise<void> {
    const token = localStorage.getItem("token");
    const praxisId = JSON.parse(localStorage.getItem("praxis") || "null")?.id;
    const doctorId = JSON.parse(localStorage.getItem("doctor") || "null")?.id;

    const res = await fetch(
        `${config.baseUrl}/api/charges/receipt?year=${year}&month=${month}`,
        {
            headers: {
                ...(token && { Authorization: `Bearer ${token}` }),
                ...(doctorId && { "X-Doctor-Id": doctorId }),
                ...(praxisId && { "X-Praxis-Id": praxisId }),
            },
        },
    );

    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new ApiError(res.status, body?.error ?? "Failed to download receipt", body);
    }

    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `receipt-${year}-${String(month).padStart(2, "0")}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
